import gql from "graphql-tag";

export function GET_EVENT(eventSlug) {
	return gql`
		query GetEvent {
			events(where: { name: "${eventSlug}" }) {
				nodes {
					id
					title
					slug
					date
					content
					blocksJSON
					seo {
						title
						metaDesc
						metaKeywords
						opengraphSiteName
						opengraphType
						opengraphUrl
						opengraphImage {
							sourceUrl
						}
					}
					featuredImage {
						node {
							sourceUrl
							altText
						}
					}
					qzrTargets {
						nodes {
							name
							slug
						}
					}
				}
			}
		}
	`;
}

export function GET_EVENT_PREVIEW(eventId) {
	return gql`
		query GetEventPreview {
			event(id: "${eventId}", idType: DATABASE_ID) {
				id
				title
				slug
				date
				content
				blocksJSON
				seo {
					title
					metaDesc
					metaKeywords
					opengraphSiteName
					opengraphType
					opengraphUrl
					opengraphImage {
						sourceUrl
					}
				}
				featuredImage {
					node {
						sourceUrl
						altText
					}
				}
				qzrTargets {
					nodes {
						name
						slug
					}
				}
			}
		}
	`;
}